// extracted by mini-css-extract-plugin
export default {"root":"hcx-financial-card-list-resizer_root__+20YQ"};